import UncheckedCheckboxIcon from 'assets/icons/buttons/checkbox_unchecked.svg';
import CheckedCheckboxIcon from 'assets/icons/buttons/checkbox_checked.svg';
import CheckedRadioIcon from 'assets/icons/buttons/radio_checked.svg';
import UncheckedRadioIcon from 'assets/icons/buttons/radio_unchecked.svg';
import { IAudienceToggleItem, TAudienceToggleItemIcons } from './types';

export const AudienceToggleItem = ({ type, isSelected }: IAudienceToggleItem) => {
  const icons: TAudienceToggleItemIcons = {
    radio: { checked: CheckedRadioIcon, unchecked: UncheckedRadioIcon },
    checkbox: { checked: CheckedCheckboxIcon, unchecked: UncheckedCheckboxIcon },
  };

  const Checked = icons[type].checked;
  const Unchecked = icons[type].unchecked;

  return isSelected ? <Checked /> : <Unchecked />;
};
